/* @flow */

import React from "react";
import { connect } from "react-redux";
import Button from "../../Button";
import FilePicker from "../../FilePicker";
import Fieldset from "../../Fieldset";
import Link from "../../Link";
import styles from "./LoaAuthorisation.scss";
import { DocumentCollectionStep } from "./DocumentCollectionStep";
import type { RootState } from "../../../types";
import countryConfig from "../../../countryConfig";

export const LOA_OBJECT_TYPE = "LOA";

export class LoaAuthorisation extends DocumentCollectionStep {
  render() {
    const loaUrl = countryConfig[this.props.countryCode]?.loaUrl;

    return (
      <React.Fragment>
        <Fieldset
          title="Letter of Authorisation"
          description={
            <div>
              To confirm that someone with significant responsibility at the
              business — such as CEO, CFO, Owner, or Managing Director — has
              authorised you to manage this PayPal account, we ask for a
              completed Letter of Authorisation.{" "}
              {loaUrl && (
                <div className={styles.downloadLink}>
                  <Link href={loaUrl} intent="primary" target="_blank">
                    Download a sample Letter of Authorisation
                  </Link>
                </div>
              )}
            </div>
          }>
          <FilePicker
            acceptType=".pdf, .png, .jpg, .jpeg"
            objectType={LOA_OBJECT_TYPE}
            description={
              "Upload the completed and signed Letter of Authorisation. " +
              "Accepted file formats: PDF, JPG, or PNG. File size is limited to 10 MB. " +
              "Adding documentation is optional at this time; however, we will request it later during the application review process."
            }
            files={this.state.documents}
            onFileUpload={this.handleFileCollectionAdd}
            onFileRemove={this.handleFileCollectionRemove}
            onFileUploadStatus={this.handleFileUploadStatusChange}
          />
        </Fieldset>

        <Button
          intent="primary"
          fullWidth={true}
          onClick={this.commitDocuments}
          disabled={this.props.ui.asyncActionInFlight}>
          Continue
        </Button>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ ui, countryCode }: RootState) => ({
  ui,
  countryCode
});

// $FlowFixMe
export default connect(mapStateToProps)(LoaAuthorisation);
